import { useState, useEffect } from "react";
import styles from "./index.module.scss";
import { Radio } from "antd";
import FileList from "./FileList";
import FileGrid from "./FileGrid";
import PreviewPane from "./PreviewPane";
import buildDirectoryTree from "@/utils/buildDirectoryTree";
import intl from "react-intl-universal";

const FileManager = ({  files, resourceUuid }) => {
  const [directoryTree, setDirectoryTree] = useState([]);
  useEffect(() => {
    setDirectoryTree(buildDirectoryTree(files));
  }, [files]);
  const options = [
    {
      label: intl.get("List View"),
      value: "list",
    },
    {
      label: intl.get("Grid View"),
      value: "grid",
    },
    {
      label: intl.get("Preview View"),
      value: "preview",
    },
  ];

  const [viewType, setViewType] = useState("list"); //list->列表  grid->缩略图
  const [curData, setCurFile] = useState(null);
  const onChangeType = ({ target: { value } }) => {
    setViewType(value);
  };
  const previewFileData = (data) => {
    setCurFile(data);
    setViewType("preview");
  };
  return (
    <div>
     
      <div className={styles.fileManagerContainer}>
        <div className={styles.typeWrap}>
          <Radio.Group
            options={options}
            onChange={onChangeType}
            value={viewType}
            optionType="button"
          />
        </div>
        <div className={styles.contentWrap}>
          {viewType === "list" ? (
            <FileList
              resourceUuid={resourceUuid}
              previewFileData={previewFileData}
              curData={curData}
              directoryTree={directoryTree}
            />
          ) : viewType === "grid" ? (
            <FileGrid
              resourceUuid={resourceUuid}
              previewFileData={previewFileData}
              curData={curData}
              directoryTree={directoryTree}
            />
          ) : (
            <PreviewPane
              resourceUuid={resourceUuid}
              previewFileData={previewFileData}
              curData={curData}
              directoryTree={directoryTree}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default FileManager;
